export const AIRTABLE_BASE_ID = 'apphg9xAXH7ZaCSir';

export const airtableUrl = (tableId: string, recordId: string): string =>
  `https://airtable.com/${AIRTABLE_BASE_ID}/${tableId}/${recordId}`;

export function splitName(name: string): { first: string; last: string } {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return { first: parts[0] ?? '', last: parts.slice(1).join(' ') };
}
